const setSearch = (state = "", action) => {
  switch (action.type) {
    case "SETSEARCH":
      return action.payload;
    default:
      return state;
  }
};

export default setSearch;
